export const visitActionsSelector = state => state.visitActions;
